// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"10c7c037","836":"6e032cd8","843":"2af72025"}[chunkId] + ".chunk.js";
};